import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { FlaskConical, RefreshCw, Trash2, X } from 'lucide-react';
import { getToken } from '../../services/tokenService';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SuppressionMasseBar({ recus, selected, setSelected, onDone }) {
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${getToken()}` };
  const pageIds = recus.map(r => r.id);
  const toutePage = pageIds.length > 0 && pageIds.every(id => selected.has(id));

  const basculerPage = () => setSelected(prev => {
    const next = new Set(prev);
    pageIds.forEach(id => (toutePage ? next.delete(id) : next.add(id)));
    return next;
  });

  const cocherTests = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/recus-ess/ids-test`, { headers });
      setSelected(prev => new Set([...prev, ...data.ids]));
      toast.info(data.total ? `${data.total} reçu(s) « test » coché(s), toutes pages confondues` : 'Aucun reçu « test » trouvé');
    } catch { toast.error('Recherche des reçus test impossible'); }
  };

  const supprimer = async () => {
    if (!window.confirm(`Supprimer définitivement ${selected.size} reçu(s) ESS ?\n\nLes reçus acquittés des souscriptions ne seront pas modifiés.`)) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/recus-ess/supprimer-masse`, { ids: [...selected] }, { headers });
      toast.success(data.message);
      setSelected(new Set());
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur lors de la suppression'); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-2 px-1" data-testid="recus-masse-bar">
      <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
        <input type="checkbox" checked={toutePage} onChange={basculerPage} className="h-4 w-4 accent-orange-500" data-testid="recus-masse-page" />
        Toute la page
      </label>
      <Button variant="outline" size="sm" onClick={cocherTests} className="text-xs" data-testid="recus-masse-tests">
        <FlaskConical className="h-3.5 w-3.5 mr-1" /> Cocher les reçus « test »
      </Button>
      {selected.size > 0 && (
        <>
          <span className="text-sm font-semibold text-gray-700" data-testid="recus-masse-compte">{selected.size} sélectionné(s)</span>
          <Button size="sm" onClick={supprimer} disabled={busy} className="text-xs bg-red-600 hover:bg-red-700 text-white" data-testid="recus-masse-supprimer">
            {busy ? <RefreshCw className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Trash2 className="h-3.5 w-3.5 mr-1" />} Supprimer la sélection
          </Button>
          <Button variant="ghost" size="sm" onClick={() => setSelected(new Set())} className="text-xs" data-testid="recus-masse-vider">
            <X className="h-3.5 w-3.5 mr-1" /> Tout décocher
          </Button>
        </>
      )}
    </div>
  );
}
